// src/features/institutions/institution.slice.ts
// UI state for institutions — filters, drawer, selected institution.
import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { InstitutionTabFilter } from './institution.types'

interface InstitutionUIState {
  activeTab: InstitutionTabFilter
  searchQuery: string
  isDrawerOpen: boolean
  selectedId: number | null
  currentPage: number
  pageSize: number
}

const initialState: InstitutionUIState = {
  activeTab: 'ALL',
  searchQuery: '',
  isDrawerOpen: false,
  selectedId: null,
  currentPage: 0,
  pageSize: 10,
}

const institutionSlice = createSlice({
  name: 'institution',
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<InstitutionTabFilter>) => {
      state.activeTab = action.payload
    },
    setSearchQuery: (state, action: PayloadAction<string>) => {
      state.searchQuery = action.payload
    },
    openDrawer: (state) => {
      state.isDrawerOpen = true
    },
    closeDrawer: (state) => {
      state.isDrawerOpen = false
      state.selectedId = null
    },
    setSelectedId: (state, action: PayloadAction<number | null>) => {
      state.selectedId = action.payload
    },
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload
    },
    resetPage: (state) => {
      state.currentPage = 0
    },
  },
})

export const {
  setActiveTab,
  setSearchQuery,
  openDrawer,
  closeDrawer,
  setSelectedId,
  setCurrentPage,
  resetPage,
} = institutionSlice.actions

export default institutionSlice.reducer